import socketIOClient from 'socket.io-client';

export const HANDLERS = {
	CONNECT: 'connect',
	ONLINE_PLAYERS: 'onlinePlayers',
	PROXY: 'proxy',
	GAME_STATUS: 'gameStatus',
	JOINED_PLAYERS: 'joinedPlayers',
	PLAYERS_DISCONNECTED: 'playerDisconnected',
	GAME_DATA: 'gameData',
	SEND_LINK: 'sendLink',
};

export const COMMANDS = {
	REDIRECT: 'redirect',
	JOIN_GAME: 'joinGame',
	CANCEL_FIND_OPPONENT: 'cancelFindOpponent',
	FIND_OPPONENT: 'findOpponent',
	PROXY: 'proxy',
};

class SocketManager {
	static connection = null;

	static handlers = {};

	static connect() {
		// @TODO FIX
		console.log(process.env.GATSBY_WEB_SOCKET_URL, process.env.GATSBY_WEB_SOCKET_URL_PATH);
		this.connection = socketIOClient('https://fatcatarena.com', {
			path: '/ws/socket.io',
			transports: ['websocket'],
		});
		this.connection.on('connect_error', (err) => {
			console.log(`connect_error due to ${err.message}`);
		});
		this.connection.on('error', (error) => {
			console.error(error);
		});
		this.connection.on('joinedPlayers', (data) => {
			console.log(data);
		});
		this.bindHandlers();
	}

	static disconnect() {
		if (this.isConnected()) {
			this.connection.disconnect();
		}
	}

	static bindHandlers() {
		Object.values(HANDLERS).forEach(handler => this.connection.on(handler, (data) => {
			if (this.handlers[handler]) {
				this.handlers[handler](data, this.connection);
			}
		}));
	}

	static registerHandler(event, callback) {
		this.handlers[event] = callback;
	}

	static unregisterHandler(event) {
		if (typeof this.handlers[event] !== 'undefined') {
			delete this.handlers[event];
		}
	}

	static sendMessage(command, value) {
		if (this.isConnected()) {
			this.connection.emit(command, value);
		}
	}

	// Information
	static isConnected() {
		return this.connection.connected;
	}
}

export default SocketManager;
